import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';

 export const fetchGetSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});

export const fetchDataSuccess = (addcontry: any) => ({
    type: 'FETCH_Addcountry_SUCCESS',
    payload: addcontry,
});
export const fetchupdateSuccess = (updatedata: any) => ({
    type: 'FETCH_Update_SUCCESS',
    payload: updatedata,
});
export const fetchRemoveSuccess = (remove: any) => ({
    type: 'FETCH_Remove_SUCCESS',
    payload: remove,
});


export const getData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1};
            const apiname = Admin_API.country_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchGetSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


export const AddData = (clabel:any,cname:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {cname:cname,clabel:clabel,q:2};
            const apiname = Admin_API.country_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const updateData = (countrylabel:any,CountryName:any,CountryID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,clabel:countrylabel,cname:CountryName,cid:CountryID};
            const apiname = Admin_API.country_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchupdateSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const  removeData = (CountryID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,cid:CountryID};
            const apiname = Admin_API.country_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRemoveSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};



